
import * as d3 from "../lib/d3.js";

const table = JSON.parse(d3.select("#translations").text());

/**
 * A string template processor that looks up and returns translations for the specified string.
 *
 * <pre>
 *     tr`Wind`  // "Vent"
 * </pre>
 *
 * @param {string[]} parts
 * @returns {string} the translated string
 */
export function tr(parts) {
    if (parts.length > 1) {
        throw new Error("NYI");  // substitutions not supported
    }
    const key = parts[0];  // parts.join("{i++}")
    return table[key] ?? key;
}
